
document.addEventListener("DOMContentLoaded", function () {
  const steps = document.querySelectorAll(".step-content");
  const progressFill = document.querySelector(".progress-fill");
  const nextBtn = document.querySelector(".next-btn");
  const prevBtn = document.querySelector(".prev-btn");
  let currentStep = 1;

  const updateUI = () => {
    steps.forEach(step => {
      step.style.display = parseInt(step.dataset.step) === currentStep ? "block" : "none";
    });

    document.querySelectorAll(".progress-bar .step, .step-titles .title").forEach(el => {
      el.classList.toggle("active", parseInt(el.dataset.step) === currentStep);
    });

    progressFill.style.width = ((currentStep - 1) / (steps.length - 1)) * 100 + "%";
    nextBtn.disabled = currentStep === steps.length;
    prevBtn.disabled = currentStep === 1;
  };

  // -----------------------------
  // Step 1 → Step 2 Logic
  // -----------------------------
  const step1Radios = document.querySelectorAll('input[name="window_type"]');
  const priceEffectBlock = document.querySelector('.price_effect_options');
  const noPriceEffectBlock = document.querySelector('.noprice_effect_options');

  function getStep1Selection() {
    const selectedOption = document.querySelector('input[name="window_type"]:checked');
    return selectedOption ? selectedOption.value : null;
  }

  function updateStep2Options() {
    const selected = document.querySelector('input[name="window_type"]:checked');

    if (selected && selected.id === 'radio-first-step1-main') {
      priceEffectBlock.style.display = 'block';
      noPriceEffectBlock.style.display = 'none';
    } else if (selected && selected.id === 'radio-second-step1-main') {
      priceEffectBlock.style.display = 'none';
      noPriceEffectBlock.style.display = 'block';
    }
  }

  // Initial call for Step 1 logic
  updateStep2Options();

  // Bind change events
  step1Radios.forEach(radio => {
    radio.addEventListener('change', () => {
      // console.log('Step 1 Selection:', getStep1Selection());
      updateStep2Options();
    });
  });

  // -----------------------------
  // Step 2 → Step 3 Logic Helper
  // -----------------------------
  function getStep2Option() {
    const selected = document.querySelector('input[name="tape"]:checked');
    return selected?.dataset.option || null;
  }

  // -----------------------------
  // Generic Radio Toggle Handler
  // -----------------------------
  function handleRadioToggle(groupName, containerSelector = '') {
    const radios = document.querySelectorAll(`input[name="${groupName}"]`);
    
    radios.forEach(radio => {
      radio.addEventListener("change", () => {
        const scope = containerSelector ? document.querySelector(containerSelector) : document;

        // Hide all details
        scope.querySelectorAll(".radio_main_details").forEach(detail => {
          detail.style.display = "none";
        });

        // Show the detail for the selected radio
        const selectedLabel = radio.closest(".radio-selection");
        const detailBlock = selectedLabel.querySelector(".radio_main_details");
        if (radio.checked && detailBlock) {
          detailBlock.style.display = "block";
        }
      });

      // ➕ Immediately show the detail block if this radio is checked on load
      if (radio.checked) {
        const selectedLabel = radio.closest(".radio-selection");
        const detailBlock = selectedLabel.querySelector(".radio_main_details");
        if (detailBlock) {
          detailBlock.style.display = "block";
        }
      }
    });
  }

  // Initialize radio toggles
  handleRadioToggle("window_type"); // Step 1 details
  handleRadioToggle("tape");        // Step 2 details
  handleRadioToggle("gliter-eyelet-option", ".step-content[data-step='3']"); // Step 3 details
  handleRadioToggle("vorhang_type");

  
nextBtn.addEventListener("click", () => {
  // STEP 2 Validation
  if (currentStep === 2) {
    const selected = document.querySelector('input[name="tape"]:checked');
    const option = selected?.dataset.option || null;
    const skipStep = selected?.dataset.skipStep === "true";
    const errorEl = document.getElementById("step2-error");

    if (!option) {
      errorEl.style.display = "block";
      return;
    } else {
      errorEl.style.display = "none";
    }

    document.querySelector(".gleiter-options")?.style.setProperty("display", "none");
    document.querySelector(".eyelets-options")?.style.setProperty("display", "none");

    if (option === "ribbon") {
      document.querySelector(".gleiter-options")?.style.setProperty("display", "block");
    } else if (option === "eyelet") {
      document.querySelector(".eyelets-options")?.style.setProperty("display", "block");
    }

    currentStep = skipStep ? 4 : 3;
    updateUI();
    return;
  }

  // STEP 3 Validation
  if (currentStep === 3) {
    const selected = document.querySelector('input[name="gliter-eyelet-option"]:checked');
    if (!selected) {
      document.getElementById("step3-error").style.display = "block";
      return;
    } else {
      document.getElementById("step3-error").style.display = "none";
    }

    currentStep = 4;
    updateUI();
    return;
  }
if (currentStep === 4) {
  const widthInput = document.getElementById("width");
  const heightInput = document.getElementById("height");

  const width = widthInput.value.trim();
  const height = heightInput.value.trim();

  const minWidth = Number(widthInput.dataset.min || 0);
  const maxWidth = Number(widthInput.dataset.max || Infinity);
  const minHeight = Number(heightInput.dataset.min || 0);
  const maxHeight = Number(heightInput.dataset.max || Infinity);

  let isValid = true;

  // ✅ Step 4 simple empty field check
  if (width === "" || height === "") {
    document.getElementById("step4-error").textContent = "Bitte geben Sie sowohl die Breite als auch die Höhe ein, um fortzufahren.";
    document.getElementById("step4-error").style.display = "block";
    return;
  } else {
    document.getElementById("step4-error").style.display = "none";
  }

  // ✅ Convert to number
  const widthNum = Number(width);
  const heightNum = Number(height);

  // ✅ Width Validation
  if (widthNum < minWidth) {
    document.getElementById("min-width-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("min-width-error").style.display = "none";
  }

  if (widthNum > maxWidth) {
    document.getElementById("max-width-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("max-width-error").style.display = "none";
  }

  // ✅ Height Validation
  if (heightNum < minHeight) {
    document.getElementById("min-height-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("min-height-error").style.display = "none";
  }

  if (heightNum > maxHeight) {
    document.getElementById("max-height-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("max-height-error").style.display = "none";
  }

  // ✅ Don't proceed if any validation fails
  if (!isValid) {
    return;
  }

  // ✅ All good — move to next step
  currentStep = 5;
  updateUI();
  return;
}

// STEP 5 Validation
if (currentStep === 5) {
  const selected = document.querySelector('input[name="vorhang_type"]:checked');
  if (!selected) {
    document.getElementById("step5-error").style.display = "block";
    return; // stop progression
  } else {
    document.getElementById("step5-error").style.display = "none";
  }

  // ✅ Proceed to next step
  currentStep = 6;
  updateUI();
  return;
}

 
  // Fallback - go to next step
  if (currentStep < steps.length) {
    currentStep++;
    updateUI();
  }
});


// Auto-hide "Please select" error when fields are filled
const widthInput = document.getElementById("width");
const heightInput = document.getElementById("height");
const step4Error = document.getElementById("step4-error");

function checkIfBothFilled() {
  if (widthInput.value.trim() !== "" && heightInput.value.trim() !== "") {
    step4Error.style.display = "none";
  }
}

widthInput.addEventListener("input", checkIfBothFilled);
heightInput.addEventListener("input", checkIfBothFilled);




  
  // -----------------------------
  // Previous Button Logic
  // -----------------------------
prevBtn.addEventListener("click", () => {
  // Step 5: Clear vorhang_type
  if (currentStep === 5) {
    document.querySelectorAll('input[name="vorhang_type"]').forEach(r => r.checked = false);
    const vorhangSummary = document.querySelector(".summary-vorhang");
    if (vorhangSummary) {
      vorhangSummary.parentElement.style.display = "none";
    }
  }


 // Step 4: clear width & height (✅ your actual requirement)
  if (currentStep === 4) {
    const widthInput = document.getElementById("width");
    const heightInput = document.getElementById("height");

    if (widthInput) widthInput.value = "";
    if (heightInput) heightInput.value = "";

    document.getElementById("min-width-error").style.display = "none";
    document.getElementById("max-width-error").style.display = "none";
    document.getElementById("min-height-error").style.display = "none";
    document.getElementById("max-height-error").style.display = "none";
    document.getElementById("step4-error").style.display = "none";

const step4Summary = document.querySelector(".summary-mass");
if (step4Summary && step4Summary.parentElement) {
  step4Summary.parentElement.style.display = "none";
}

  }

  // Step 3: Clear gliter-eyelet-option
  if (currentStep === 3) {
    document.querySelectorAll('input[name="gliter-eyelet-option"]').forEach(r => r.checked = false);
    const gliterSummary = document.querySelector(".gliter-eyelet-option");
    if (gliterSummary) {
      gliterSummary.parentElement.style.display = "none";
    }
  }

  // Step 2: Clear tape option
  if (currentStep === 2) {
    document.querySelectorAll('input[name="tape"]').forEach(r => r.checked = false);
    const bandSummary = document.querySelector(".summary-determination-dimensions");
    if (bandSummary) {
      bandSummary.parentElement.style.display = "none";
    }
  }

  // Special skip logic
  if (currentStep === 4 && getStep2Option() === "hidden") {
    currentStep = 2;
  } else {
    currentStep--;
  }

  updateUI(); // update UI after step change
});


  // Initialize UI
  updateUI();
});

